import React, { useEffect } from 'react'

import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'
import { useSessionContext } from 'hooks/SessionContext'

import UpgradeModal from 'pages/shared/UpgradeModal'

type Props = {
  closeCallback: (reloadPage) => void
}

const PaywallAcceptModal = ({ closeCallback }: Props) => {
  const { session } = useSessionContext()

  useEffect(() => {
    Apptentive.sendEvent('premium_acct_created')

    GA4.sendEvent({
      action: 'Premium Account Created',
      category: 'Premium Settings'
    })

    if (session?.dealerPlan) {
      Apptentive.updatePerson(session.dealerPlan)

      if (session.dealerPlan.in_trial) {
        Apptentive.sendEvent('premium_trial_started')
        GA4.sendEvent({ category: 'Premium', action: 'Premium Trial Started' })
      } else {
        Apptentive.sendEvent('premium_started')
        GA4.sendEvent({ category: 'Premium', action: 'Premium Started' })
      }
    }
  }, [session])

  return (
    <UpgradeModal closeCallback={closeCallback} />
  )
}

export default PaywallAcceptModal
